import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import DeviceProperties from "../Core/device-properties.js";

var Ie = /*#__PURE__*/function () {
  function Ie(s) {
    _classCallCheck(this, Ie);

    this.id = s;
  }

  _createClass(Ie, [{
    key: "li",
    value: function li() {
      var s = {};
      return null != this[DeviceProperties.BROWSER] && (s.browser = this[DeviceProperties.BROWSER]), null != this[DeviceProperties.BROWSER_VERSION] && (s.browser_version = this[DeviceProperties.BROWSER_VERSION]), null != this[DeviceProperties.OS] && (s.os_version = this[DeviceProperties.OS]), null != this[DeviceProperties.RESOLUTION] && (s.resolution = this[DeviceProperties.RESOLUTION]), null != this[DeviceProperties.LANGUAGE] && (s.locale = this[DeviceProperties.LANGUAGE]), null != this[DeviceProperties.TIME_ZONE] && (s.time_zone = this[DeviceProperties.TIME_ZONE]), null != this[DeviceProperties.USER_AGENT] && (s.user_agent = this[DeviceProperties.USER_AGENT]), s;
    }
  }]);

  return Ie;
}();

export { Ie as default };